import React from 'react';
import ReactDOM from 'react-dom';
import { CalendarApp } from './CalendarApp';
import './style.css'
import 'animate.css';

ReactDOM.render(
    <CalendarApp />
  ,document.getElementById('root')
);

